// Module
var code = "<html> <head><title>test</title></head> <body> <h1>offline max</h1> </body> </html>";
// Exports
module.exports = code;